module.exports = __webpack_public_path__ + "img/scheme.9b22b426.svg";